import { useEffect, useState } from "react";
import PageWrapper from "../../components/common/PageWrapper";
import Header from "../../components/common/Header";
import BodyWrapper from "../../components/common/BodyWrapper";
import Footer from "../../components/common/Footer";
import Wrapper from "../../components/dashboard/dashboardPartials/Wrapper";
import axios from "../../config/axios";
import { useGeneral } from "../../components/contexts/GeneralContext";
import { useNavigate, useParams } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";
const usePageContent = () => {
  const [loading, setLoading] = useState(true);
  const [content, setContent] = useState([]);
  const [error, setError] = useState("");
  const { discountCoupons } = useGeneral();
  const { id } = useParams();

  useEffect(() => {
    let active = true;

    (async () => {
      try {
        const { data } = await axios.get(`/dashboard/notifications/${id}`);

        if (active) {
          setContent(data);

          // ✅ If notification was unread, update unread count in localStorage
          if (data?.item?.isSeenByReceiver === "0") {
            const storedCount = JSON.parse(localStorage.getItem("unreadMessagesCount")) || 0;
            const newCount = Math.max(0, storedCount - 1);
            localStorage.setItem("unreadMessagesCount", JSON.stringify(newCount));
          }
        }
      } catch (err) {
        console.error(err);
        if (active) setError("Failed to load notification. Please try again later.");
      } finally {
        if (active) setLoading(false);
      }
    })();

    return () => {
      active = false;
    };
  }, [id]);

  return { content, loading, error, discountCoupons };
};


const useScrollToTop = () => {
  useEffect(() => {
    const timer = setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 100);
    return () => clearTimeout(timer);
  }, []);
};

const NotificationsDetailsPage = () => {
  const { content, loading, error, discountCoupons } = usePageContent();
  useScrollToTop();
  const navigate = useNavigate();
  return (
    <PageWrapper loading={false} className="bg-bg min-h-screen">
      <Header code={discountCoupons} />

      <BodyWrapper className="mb-0 xl:mb-0">
        <Wrapper goBack={true}
          component={
            <div className="">
              <div className="mt-6 w-full bg-[#DEE2DD]/40 rounded-[15px] px-6 pt-6 pb-8 lg:px-12 overflow-auto">
                <div className="flex items-center gap-4 mb-4">
                  {/* <button
                    onClick={() => navigate(-1)}
                    title="Click to go back"
                    className="flex items-center gap-2 pe-3 py-2 bg-gray-200 rounded hover:bg-gray-300 transition"
                  >
                    <FiArrowLeft size={30} />
                  </button> */}
                  <p className="text-24pt">Notification Details</p>
                </div>
                {/* Notification List */}

                <div
                  key={content?.item?._id}
                  className={`flex items-start mb-4 p-4 rounded-[10px] relative ${
                    content?.item?.isSeenByReceiver === "0"
                      ? "bg-[#fff]/80 border border-gray "
                      : "bg-[#fff] border border-[#A0AE3F]/60"
                  }`}
                >
                 

                  {/* Content */}
                  <div className="flex-1 flex flex-col gap-1 py-2">
                    <div className="flex items-center gap-2 absolute right-2 top-1">
                      {/* Status Badge */}

                      <p className="text-12pt text-[#808080] font-mono">
                        {content?.item?.createdAt}
                      </p>
                    </div>

                    {/* Description */}
                    <p className="text-24pt mb-1">{content?.item?.message}</p>

                    {/* Category Badge */}
                    <p className="text-14pt mt-0.5 inline-flex items-center gap-2">
                      <span
                        className={`px-3 py-0.5 rounded-full text-12pt font-mono ${
                          content?.item?.importance === "Medium"
                            ? "bg-green/10 text-green border border-green/30"
                            : content?.item?.importance === "High"
                            ? "bg-orange/10 text-orange border border-orange/30"
                            : content?.item?.importance === "Low"
                            ? "bg-secondary/10 text-secondary border border-secondary/30"
                            : "bg-secondary/10 text-secondary border border-secondary/30"
                        }`}
                      >
                        {content?.item?.importance}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          }
        />
      </BodyWrapper>

      <Footer />
    </PageWrapper>
  );
};

export default NotificationsDetailsPage;
